<template>
  <div class="p-4" v-if="user">
    <!-- Header -->
    <div class="flex justify-between items-center h-fit mb-4">
      <div class="flex w-full items-center">
        <!-- Bouton retour -->
        <button class="h-fit !m-0 !px-2 !bg-transparent flex items-center justify-center text-gray-400 !font-normal cursor-pointer" @click="$router.go(-1)">
          <i class="fa-solid fa-arrow-left "></i>
          <div class="!text-2xl">&nbsp;Utilisateurs/</div>
        </button>
        <!-- Titre -->
        <input
          class="basicInput w-1/2 text-xl text-left flex items-center truncate"
          type="text"
          v-model="user.name"
          placeholder="Nom de l'utilisateur"
          :disabled="currentUserPermissions.users?.permission !== 'modification'"
        >
      </div>
    </div>

    <!-- Informations générales -->
    <div class="flex gap-4 w-full">
      <div class="flex-grow flex flex-col w-full h-fit">
        <div class="font-semibold text-left mb-1">Email</div>
        <input
        class="basicInput w-full"
        type="email"
        v-model="user.email"
        placeholder="Email de l'utilisateur"
        disabled
        >
        <span class="text-gray-500 text-sm mt-2 text-left">Peut-être changé dans l'espace compte</span>
      </div>
      <div class="flex-grow flex flex-col w-full h-fit">
        <div class="font-semibold text-left mb-1">Mot de passe par défaut</div>
        <input
          class="basicInput w-full"
          type="email"
          v-model="user.defaultPassword"
          placeholder="Mot de passe par défaut"
          disabled
        >
        <span class="text-gray-500 text-sm mt-2 text-left">Peut être changé avec "Mot de passe oublié ?"</span>
      </div>
    </div>

    <div class="border border-gray-300 my-4"></div>

    <div class="mb-2 font-bold text-left !w-full text-lg">Permissions de l'utilisateur</div>
    <div
      class="basicInput !h-fit justify-between flex items-center mb-4"
      v-for="perm in sortedPermissions"
      :key="perm.key"
    >
      <span class="select-none">{{ perm.name }}</span>
      <div class="flex items-center">
        <button
          :class="perm.permission == 'modification' ? 'callToAction' : ''"
          class="!rounded-r-none"
          @click="user.permissions[perm.key].permission = 'modification'"
          :disabled="currentUserPermissions.users?.permission !== 'modification' || isCurrentUser"
        >
          Modification
        </button>
        <button
          :class="perm.permission == 'consultation' ? 'callToAction' : ''"
          class="!rounded-none"
          @click="user.permissions[perm.key].permission = 'consultation'"
          :disabled="currentUserPermissions.users?.permission !== 'modification' || isCurrentUser"
        >
          Consultation {{ perm.key === 'planning' || perm.key === 'projects' ? '(Tous)' : '' }}
        </button>
         <button v-if="perm.key === 'planning' || perm.key === 'projects'"
          :class="perm.permission == 'consultation_solo' ? 'callToAction' : ''"
          class="!rounded-none"
          @click="user.permissions[perm.key].permission = 'consultation_solo'"
          :disabled="currentUserPermissions.users?.permission !== 'modification' || isCurrentUser"
        >
          Consultation (Ressource associée)
        </button>
        <button
          :class="perm.permission == 'none' ? 'callToAction' : ''"
          class="!rounded-l-none"
          @click="user.permissions[perm.key].permission = 'none'"
          :disabled="currentUserPermissions.users?.permission !== 'modification' || isCurrentUser"
        >
          Aucun
        </button>
      </div>
    </div>
  </div>
</template>

<script>

import { getUserById, updateUser } from '@/services/userService';
import { getAuth } from 'firebase/auth';

export default {
  name: "UserDetails",
  props: {
    id: String
  },
  data() {
    return {
      user: null,
      currentUserPermissions: {},
      isCurrentUser: false, // Ajouté
    };
  },
  computed: {
    sortedPermissions() {
      if (!this.user || !this.user.permissions) return [];
      return Object.entries(this.user.permissions)
        .map(([key, value]) => ({ key, ...value }))
        .sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
    }
  },
  methods: {},
  async mounted() {
    this.user = await getUserById(this.id);

    const auth = getAuth();
    const currentUser = auth.currentUser;
    if (currentUser) {
      const currentUserData = await getUserById(currentUser.uid);
      this.currentUserPermissions = currentUserData.permissions || {};
      this.isCurrentUser = currentUser.uid === this.id; // Ajouté
    }
  },
  watch: {
    user: {
      handler(newUser) {
        updateUser(this.user);
      },
      deep: true,
    },
  },
};
</script>